// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"5336": "5083bc5218c4","5461": "4abfb4091f55","6171": "eb7b6e076c0d","6863": "454c9f289029","8357": "dd422574e14d",}[chunkId] + ".css"
}